import React from 'react';
import { ROUTE_URL } from '@/helper/constants';
import { NoneLayout } from '@/components';

const Test5 = React.lazy(
  () => import(/* webpackChunkName: "demo-test5" */ '@/pages/demo/test5'),
);

export default [
  {
    path: `/demo/test5`,
    component: Test5,
    isAuth: false,
    layout: NoneLayout,
  },
];
